<template>
   <div class="page_header2">
      <div class="header_top ">
         <div class="max_width">
            <div class="header_logo">
               <router-link to="/">
                  <img :src="logo" alt="">
               </router-link>
            </div>
            <div class="header_right">
               <input type="text" v-model="searchText" name="searchText" placeholder="输入关键词">
               <button type="button" @click="goSearch" class="iconfont">&#xe60c;</button>
               <!-- <a href="http://old.bjia.org/" target="_blank" class="old_website">旧网站</a> -->
            </div>
         </div>
      </div>
      <div class="header_list">
         <div class="max_width">
            <ul>
               <li v-for="(item,index) in navlist" :class="index === active ?'active':''">
                  <router-link :to="item.url" v-if="item.linkType == 1">{{item.name}}</router-link>
                  <a v-else-if="item.linkType == 2" :href="item.url" target="_blank">{{item.name}}</a>
				  <a v-else-if="item.linkType == 0">{{item.name}}</a>
                  <ol v-if="item.menuType == 1">
                     <li v-for="(item2,index) in item.child">
                        <router-link :to="item2.url" v-if="item2.linkType == 1">{{item2.name}}</router-link>
                        <a v-else-if="item.linkType == 2" :href="item2.url" target="_blank">{{item2.name}}</a>
                     </li>
                  </ol>
				  <ol v-if="item.menuType == 10">
				     <li v-for="(item2,index) in item.child">
				        <router-link :to="item2.url" v-if="item2.linkType == 1">{{item2.name}}</router-link>
				        <a v-else-if="item2.linkType == 2" :href="item2.url" target="_blank">{{item2.name}}</a>
				     </li>
				  </ol>
               </li>
            </ul>
         </div>
      </div>
   </div>
</template>


<script>
   import "@/assets/css/header.less"
   export default {
      name: 'pageHeader',
      components: {

      },
      data() {
         return {
            logo: require('@/assets/images/2023/logo_2023.png'),
            navlist: [
            /*   {
                  name: '首页',
                  linkType: 1, //1内链接 2外链
                  url: '/',
                  child: []
               },
               {
                  name: '协会概况',
                  linkType: 1, //1内链接 2外链
                  url: '/list/3qYZBv/info/yayI7n',
                  menuType:1,
                  child: [{
                        name: '协会介绍',
                        url: '/list/3qYZBv/info/yayI7n',
                        linkType: 1, //1内链接 2外链
                     },
                     {
                        name: '协会章程',
                        url: '/list/3qYZBv/info/3aIFr2',
                        linkType: 1, //1内链接 2外链
                     },
                     {
                        name: '机构设置',
                        url: '/list/3qYZBv/info/qQvAFj',
                        linkType: 1, //1内链接 2外链
                     },
                  ]
               },
               {
                  name: '会员服务',
                  linkType: 1, //1内链接 2外链
                  url: '/member',
                  child: [{
                        name: '理事会名单',
                        url: '/',
                        linkType: 1, //1内链接 2外链
                     },
                     {
                        name: '会员名单',
                        url: '/',
                        linkType: 1, //1内链接 2外链
                     },
                     {
                        name: '入会须知',
                        url: '/',
                        linkType: 1, //1内链接 2外链
                     },
                  ]
               },
               {
                  name: '新闻中心',
                  linkType: 1, //1内链接 2外链
                  url: '/list/news',
                  child: [{
                        name: '内审要闻',
                        url: '/list/news?rCode=yqqMny',
                        linkType: 1, //1内链接 2外链
                     },
                     {
                        name: '动态信息',
                        url: '/list/news?rCode=bMfyIr',
                        linkType: 1, //1内链接 2外链
                     },
                  ]
               },
               {
                  name: '教育培训',
                  linkType: 2, //1内链接 2外链
                  url: 'http://www.bjabia.org/',
                  child: []
               },
               {
                  name: '经验交流',
                  linkType: 1, //1内链接 2外链
                  url: '/list/7',
                  child: []
               },
               {
                  name: '资料中心',
                  linkType: 1, //1内链接 2外链
                  url: '/list/vaAFjq',
                  child: [{
                        name: '内审准则',
                        url: '/list/vaAFjq?rCode=zYfAr2',
                        linkType: 1, //1内链接 2外链
                     },
                     {
                        name: '法律法规',
                        url: '/list/vaAFjq?rCode=eQnAri',
                        linkType: 1, //1内链接 2外链
                     },
                     {
                        name: '相关下载',
                        url: '/list/vaAFjq?rCode=UbUj2i',
                        linkType: 1, //1内链接 2外链
                     },
                  ]
               },
               {
                  name: '专题专栏',
                  linkType: 1, //1内链接 2外链
                  url: '/list/8',
                  child: []
               },
               {
                  name: '联系我们',
                  linkType: 1, //1内链接 2外链
                  url: '/list/fiIv2m/info/MR7ZFn',
                  child: []
               },*/
            ],
            active: '',

            searchText: '', //搜索词
         };
      },
      watch: {
         $route() {
            this.reashNav();
         }
      },
      created() {
         this.initpage();
         this.reashNav();
      },
      methods: {
         initpage() {
            var _this = this;
            _this.$api.menuList().then(res => {
               _this.loading = false;
               if (res.code == 200) {
                  _this.navlist = res.data;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });
         },
         reashNav() {
            let _this = this;
            var thisPath = _this.$route.path,
               indexs = '';
            if (thisPath == '/') {
               _this.active = 0;
               return false;
            }
            for (var i = 1; i < _this.navlist.length; i++) {
               if (thisPath.indexOf(_this.navlist[i].url) != -1) {
                  if (indexs == '') {
                     indexs = i;
                  }
               }
            }
            _this.active = indexs;
         },
         goSearch() {
            this.$router.push('/search?keyword=' + this.searchText);
         }
      }
   }
</script>
<style lang="less">

</style>
